module.exports = __webpack_public_path__ + "media/images/noticia04-639deea563362b0a174447f8f8239413.jpg";